<div class="padding">
  <form [formGroup]="debtorDetails">
    <div class="flex-container">
      <div class="flex-item form-field">
        <mat-radio-group [formControlName]="'partyTypeID'"
          [attr.aria-label]="'common.parties.individualOrBusiness' | transloco">
          <mat-radio-button name="individual-selection" class="radio-button"
          [value]="individualDebtor">{{ 'common.parties.individual.debtor' | transloco }}</mat-radio-button>
          <mat-radio-button name="business-selection" class="radio-button" [value]="businessDebtor">{{ 'common.parties.business.debtor' | transloco }}</mat-radio-button>
        </mat-radio-group>
      </div>
      @if (uiConfiguration.showEstate) {
        <div class="flex-item form-field">
          <mat-checkbox class="flex-item" [formControlName]="'isEstate'"
            name="is-estate">
            {{ 'common.labels.estate' | transloco }}
          </mat-checkbox>
        </div>
      }
    </div>

    @if (displayIndividualFields) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
            <input matInput [formControlName]="'firstName'" name="first-name" [placeholder]="'common.labels.firstName' | transloco" />
          </mat-form-field>
          <lib-error-bubble [control]="debtorDetails.controls['firstName']"
          [message]="firstNameError$"></lib-error-bubble>
        </div>
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'common.labels.middleName' | transloco }}</mat-label>
            <input matInput [formControlName]="'middleName'" name="middle-name" [placeholder]="'common.labels.middleName' | transloco" />
          </mat-form-field>
          <lib-error-bubble [control]="debtorDetails.controls['middleName']"
          [message]="middleNameError$"></lib-error-bubble>
        </div>
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
            <input matInput [formControlName]="'lastName'" name="last-name" [placeholder]="'common.labels.lastName' | transloco" />
          </mat-form-field>
          <lib-error-bubble [control]="debtorDetails.controls['lastName']"
          [message]="lastNameError$"></lib-error-bubble>
        </div>
        @if (uiConfiguration.showGeneration && generations.length > 0) {
          <div class="validated-form-field-container flex-container">
            <mat-form-field appearance="outline" class="form-field flex-item">
              <mat-label>{{ 'common.labels.generation' | transloco }}</mat-label>
              <mat-select formControlName="generationID" [placeholder]="'common.labels.generation' | transloco">
                <mat-option [value]="null">{{ 'common.labels.none' | transloco }}</mat-option>
                @for (gen of generations; track gen) {
                  <mat-option [value]="gen.value">
                    {{ gen.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <lib-error-bubble [control]="debtorDetails.controls['generationID']"
            [message]="generationError$"></lib-error-bubble>
          </div>
        }
      </div>
    }
    @if (displayIndividualFields) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="form-field flex-item" appearance="outline">
            <mat-label>{{ 'common.labels.dateOfBirth' | transloco }}</mat-label>
            <input matInput [matDatepicker]="dateOfBirth" [formControlName]="'dateOfBirth'" name="date-of-birth"
              [placeholder]="'common.labels.datePlaceholder' | transloco" />
            <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
            <mat-datepicker #dateOfBirth></mat-datepicker>
          </mat-form-field>
          <lib-error-bubble [control]="debtorDetails.controls['dateOfBirth']"
          [message]="dateOfBirthError$"></lib-error-bubble>
        </div>
      </div>
    }
    @if (displayBusinessFields) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.businessName' | transloco }}</mat-label>
            <input matInput [formControlName]="'busName'" name="business-name" [placeholder]="'common.labels.businessName' | transloco" />
          </mat-form-field>
          <lib-error-bubble [control]="debtorDetails.controls['busName']"
          [message]="busNameError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.hasContactDetails) {
      <form [formGroup]="contactDetails">
        @if (uiConfiguration.contactDetailsConfiguration?.showEmail) {
          <div class="flex-container">
            <div class="validated-form-field-container flex-container">
              <mat-form-field class="flex-item form-field" appearance="outline">
                <mat-label>{{ 'common.labels.email' | transloco }}</mat-label>
                <input matInput [formControlName]="'email'" name="email" [placeholder]="'common.labels.email' | transloco">
              </mat-form-field>
              <lib-error-bubble [control]="contactDetails.controls['email']"
              [message]="emailError$"></lib-error-bubble>
            </div>
          </div>
        }
        <lib-address-form [address]="$safeNavigationMigration(debtor.contactDetails?.address)"></lib-address-form>
      </form>
    }
    <!-- Navigation buttons -->
    <div class="flex-container padding-top">
      <button mat-raised-button (click)="clearFields()" class="padding-sides flex-item form-field previous-button"
        [attr.aria-label]="'common.buttons.clearFields' | transloco">
        {{ 'common.buttons.clearFields' | transloco }}
      </button>
      <button
        mat-raised-button
        (click)="removeDebtor()"
        class="margin-sides-15 flex-item form-field previous-button"
        [attr.aria-label]="'common.parties.delete.debtor' | transloco"
        color="warn"
        >
        {{ 'common.parties.delete.debtor' | transloco }}
      </button>
      <span class="spacer"></span>
      <span class="spacer"></span>
      <span class="spacer"></span>
      <span class="spacer"></span>
      <span class="spacer"></span>

      <button mat-raised-button (click)="saveDebtor()" color="primary" class="padding-sides flex-item form-field"
        [attr.aria-label]="'common.parties.save.debtor' | transloco">
        {{ 'common.parties.save.debtor' | transloco }}
      </button>
      <!-- [class.spinner]="this.isSaving"
      [disabled]="this.isSaving" -->
    </div>
  </form>
</div>